import React from 'react';
import CompetitionModuleNewsComponent from 'app/components/competitionModule/news/CompetitionModuleNewsComponent';
import { NewsContainer } from 'app/components/competitionModule/news/commonStyles';
import { DistrictMainPageModuleType, useDistrictMainPageTracking } from 'app/components/district/news/DistrictMainPageTracking';
export default function CompetitionModuleNewsList(_ref) {
  let {
    data,
    moduleIndex
  } = _ref;
  if (!data.length) {
    return null;
  }
  const {
    trackClickedItemPage
  } = useDistrictMainPageTracking();
  const handleOnClick = () => {
    trackClickedItemPage(DistrictMainPageModuleType.COMPETITION, moduleIndex);
  };
  return /*#__PURE__*/React.createElement(NewsContainer, {
    onClick: handleOnClick,
    "data-sentry-element": "NewsContainer",
    "data-sentry-component": "CompetitionModuleNewsList",
    "data-sentry-source-file": "CompetitionModuleNewsList.tsx"
  }, data.map(news => {
    return /*#__PURE__*/React.createElement(CompetitionModuleNewsComponent, {
      data: news,
      key: news.news.id
    });
  }));
}